import angular from "angular";
import EditOrderController from "./edit-order.controller";
import template from "./edit-order.html";
function getOrder(OrdersModel, $stateParams) {
  return OrdersModel.show($stateParams.order_id).then((response) => {
    return response.order;
  });
}
getOrder.$inject = ["OrdersModel", "$stateParams"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.crm.orders.edit", {
    url: "/edit/:order_id",
    template: template,
    controller: EditOrderController,
    controllerAs: "vm",
    resolve: {
      order: getOrder,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.crm.orders.edit", [])
  .config(config)
  .controller("EditOrderController", EditOrderController);

